export const DATE_FORMAT_MAP = {
  "MM/DD/YYYY": "MM/dd/yyyy",
  "DD/MM/YYYY": "dd/MM/yyyy",
  "YYYY/MM/DD": "yyyy/MM/dd",
};

export const TIME_FORMAT_MAP = {
  "hh:mm A": "hh:mm aa",
  "HH:mm": "HH:mm",
};
